import React, { Component } from 'react';
import { Table, Popconfirm, message } from 'antd';
import UpdateRequirement from './UpdateRequirement';
import { RequireFilter as Filter } from './Filter';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SiteComment extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        percent: 30,
        invVisible: false,
        isAdd: true,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        const { percent, sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.querySiteJoinRequire,
            data: {
                offset: current,
                limit: pageSize,
                percent,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    delete = siteJoinRequireId => {
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.deleteSiteJoinRequire,
            data: {
                siteJoinRequireId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('删除成功');
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    markResolve = siteJoinRequireId => {
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.signSiteJoinRequire,
            data: {
                siteJoinRequireId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('标记已处理成功');
                this.loadData();
            }
        }
        $.sendRequest(options)
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 85,
        }, {
            title: '需求编号',
            dataIndex: 'siteJoinRequireCode',
            key: 'siteJoinRequireCode',
            width: 100
        }, {
            title: '城市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',

        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
        }, { 
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea' 
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
        }, {
            title: '项目意向(适应症)',
            dataIndex: 'investigationMalady',
            key: 'investigationMalady',
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 150,
        }, {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName',
            width: 85,
        }, {
            title: '发布人员',
            dataIndex: 'createUserCompellation',
            key: 'createUserCompellation',
            width: 85,
        }, {
            title: '发布人员联系电话',
            dataIndex: 'createUserMobile',
            key: 'createUserMobile',
            width: 95,
        }, {
            title: '处理人员',
            dataIndex: 'handleUserCompellation',
            key: 'handleUserCompellation',
            width: 85,
        }, {
            title: '操作',
            fixed: "right",
            width: 156,
            render: (text, record) => {
                const { createUserId, status, siteJoinRequireId } = record;
                const { userId, curRole } = sessionStorage;
                const shouldShow = curRole == "PM" || curRole == "PML" || curRole == "BD" || curRole == "BDO" || curRole == "BDM" || curRole == "BO" || curRole == "VP" || curRole == "FIN" || curRole == "BA" || curRole == "BAL";
                const showMarkResolve = (shouldShow || userId == createUserId) && status != "HANDLED";
                const editDel = (userId == createUserId) && status != "HANDLED";
                return (
                    <span>
                        {showMarkResolve &&
                            <span>
                                <Popconfirm title='确定需求处理完毕，标记已处理？' onConfirm={() => this.markResolve(siteJoinRequireId)} okText="确定" cancelText="取消">
                                    <a>标记已处理</a>
                                </Popconfirm>
                            </span>
                        }
                        {editDel &&
                            <span>
                                { showMarkResolve && <span className="ant-divider" /> }
                                <a onClick={() => this.showEdit(record)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title='确定删除该中心参与项目需求？' onConfirm={() => this.delete(siteJoinRequireId)} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        }
                        {
                            !showMarkResolve && !editDel && '-'
                        }
                    </span>
                );
            },
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    showAdd = () => {
        this.setState({
            invVisible: true,
            invInfo: {},
            isAdd: true,
        })
    }

    showEdit = (record) => {
        this.setState({
            invVisible: true,
            isAdd: false,
            invInfo: record,
        })
    }

    changeinvVisible = (value) => {
        this.setState({
            invVisible: value,
        })
    }

    render() {
        const { loading, pagination, invInfo = {}, invVisible, isAdd } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    showAdd={this.showAdd}
                />
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.index}
                    loading={loading}
                    scroll={{ x: 1270 }}
                    onChange={this.handleTableChange}
                    pagination={pagination}
                />
                <UpdateRequirement info={invInfo} isAdd={isAdd} changeinvVisible={this.changeinvVisible} visible={invVisible} loadData={this.loadData} />
            </div>
        );
    }
}

export default SiteComment;


// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/Requirement.js